import { useAdminUserOrders } from '../../hooks/useAdminOrders';
import { AdminOrderRow } from './AdminOrderRow';

// Розгорнутий список усіх замовлень користувача (без урахування фільтра за
// статусом — навмисно, за рішенням власника).
export function UserOrdersPanel({ userId }: { userId: number }) {
  const { data: orders = [], isLoading, isError } = useAdminUserOrders(userId);

  if (isLoading) return <p className="mono-label px-6 py-4">ЗАВАНТАЖЕННЯ…</p>;
  if (isError) {
    return <p className="px-6 py-4 text-[13px] text-warn">Не вдалося завантажити замовлення.</p>;
  }
  if (orders.length === 0) {
    return (
      <p className="px-6 py-4 text-[13px] text-muted">У цього користувача ще немає замовлень.</p>
    );
  }

  return (
    <div className="divide-y divide-line-soft border-t border-line-soft bg-surface">
      {orders.map((order) => (
        <AdminOrderRow key={order.id} order={order} editable={false} />
      ))}
    </div>
  );
}
